import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { CustomField, type CustomFieldConstructorData } from './CustomField'
import { CustomFieldTypes } from './CustomFieldTypes'

export const CustomFieldConstructorFactory =
  Factory.Sync.makeFactory<CustomFieldConstructorData>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.random.word()),
    type: CustomFieldTypes.TEXT,
    choices: [],
    required: Factory.each(() => faker.random.boolean()),
    active: true,
  })

export const CustomFieldFactory = EntityFactory(
  CustomField,
  CustomFieldConstructorFactory
)
